// {companyId}/cdfs/{cdfId}/values?start=0&count=100

;(function(EG) {
  'use strict';

  var FETCH_MAX_COUNT;

  FETCH_MAX_COUNT = 100;

  EG.Users.Profile.Models.CustomDataField = EG.Users.Models.Base.extend({});

  EG.Users.Profile.Collections.CustomDataFields = EG.Users.Collections.Base.extend({
    model: EG.Users.Profile.Models.CustomDataField,
    initialize: function(models, options) {
      this.companyId = options.company || undefined;
      this.id = options.code || undefined;
      this.fetchCount = options.count || FETCH_MAX_COUNT;
    },
    url: function() {
      var url;

      url = '/users/pb/companies/' + this.companyId + '/cdfs/' + this.id + '/values?start=0&count=' + this.fetchCount;

      return url;
    },
    parse: function(response) {
      var cdfs;

      cdfs = response.values;

      return _.map(cdfs, function(cdf) {
        cdf.text = cdf.value;
        return cdf;
      });
    },
    setFetchCount: function(count) {
      var _count;

      _count = parseInt(count, 10);

      if (_.isNaN(_count)) {
        return;
      }

      this.fetchCount = _count;
    },
    fetchData: function() {
      var defer, self;
      defer = $.Deferred();
      self = this;
      this.fetch({
        success: function(collection, response, options) {
          defer.resolve(collection);
        },
        error: function(collection, response, options) {
          var errorMsg;

          errorMsg = EG.Users.Constants.KIBANA_ERROR_MESSAGE_FOR_FETCH;

          errorMsg = errorMsg.replace('{Module}', 'CDF');
          errorMsg = errorMsg.replace('{component}', 'cdf');
          errorMsg = errorMsg.replace('{url}', self.url());
          uitk.logger.error(errorMsg);
          defer.reject(response);
        }
      });
      return defer.promise();
    }
  });
})(EG);
